module.exports = __webpack_public_path__ + "img/Ins_Volt_L3.31b533fa.jpg";